import type WebSocket from 'ws';
import type { CloseableBridgeState } from './close-bridge-connection.js';
import {
  createEmptyDuplicateBridgeFlapTracker,
  createEmptyReconnectOutageTracker,
  createEmptyReconnectQuietSlot,
  type MainBridgeReconnectState,
} from './reconnect/index.js';

export type MainBridgeConnectionState = MainBridgeReconnectState & CloseableBridgeState;

export function createMainBridgeReconnectState(): {
  state: MainBridgeConnectionState;
  getWs: () => WebSocket | null;
} {
  const state: MainBridgeConnectionState = {
    closedByUser: false,
    reconnectAttempt: 0,
    lastReconnectCloseMeta: null,
    logBridgeOpenAsReconnect: false,
    reconnectTimeout: null,
    currentWs: null,
    mainQuiet: createEmptyReconnectQuietSlot(),
    mainOutage: createEmptyReconnectOutageTracker(),
    duplicateBridgeFlap: createEmptyDuplicateBridgeFlapTracker(),
    firehoseHandle: null,
    lastFirehoseParams: null,
    firehoseReconnectTimeout: null,
    firehoseReconnectAttempt: 0,
    firehoseGeneration: 0,
    firehoseQuiet: createEmptyReconnectQuietSlot(),
    firehoseOutage: createEmptyReconnectOutageTracker(),
    lastFirehoseReconnectCloseMeta: null,
  };

  return {
    state,
    getWs: () => state.currentWs as WebSocket | null,
  };
}
